// extracted by mini-css-extract-plugin
module.exports = {"container":"TabMenu_container__8TPix","menu":"TabMenu_menu__oqHBl"};